import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CodeSnippetComponent } from '../../../../../components/common/code-snippet/code-snippet.component';
import { ZorroTableComponent } from '../../../../../components/common/custom-table/zorro-table.component';
import { GenericModalComponent } from '../../../../../components/modal-templates/user-story-basic-view/generic-modal.component';
import { testPrioritizationModalConfig } from '../../../../../core/generic-templates/modal-config-templates';
import { INZorroOutput } from '../../../../../core/models/common';
import { ExcelExportService } from '../../../../../core/services/download-excel/excel-export.service';
import { impactedAnalysisItemColumns } from '../../../../../core/table-templates/impacted-analysis-item-table';

@Component({
  selector: 'app-impacted-analysis-item',
  standalone: true,
  imports: [CommonModule, CodeSnippetComponent, ZorroTableComponent],
  templateUrl: './impacted-analysis-item.component.html',
  styleUrl: './impacted-analysis-item.component.scss'
})
export class ImpactedAnalysisItemComponent {

  private modalService = inject(NgbModal);

  @Input()
  data: any = {};

  tableColumns: any = impactedAnalysisItemColumns;

  constructor(
    private excelExportService: ExcelExportService
  ) {
   
  }

  openDetailedModal(data: any) {
    const modalRef = this.modalService.open(GenericModalComponent, {
      centered: true,
      size: "xl",
      backdrop: 'static',
    });
    modalRef.componentInstance.data = data;
    modalRef.componentInstance.contentList =
      testPrioritizationModalConfig.impctedTestCaseMapping;
    modalRef.componentInstance.title = "Test Case to Source Code Mapping - Details";
  }

  handleTableActions(event: INZorroOutput) {
    if (event.data.column?.key === "open_modal") {
      this.openDetailedModal(event.data.row);
    }
  }

   /**
   * Exports test case data to an Excel file.
   */
   onDownload() {
      if (this.data?.mappings?.length) {
        const formattedData = this.data.mappings.map((row: any) => ({
          UserStoryId : row.userStoryId,
          UserStoryDescription : row.userStoryDescription,
          TestCaseId : row.testcaseid,
          TestCaseTitle: row.testScenario,
          SourceCodePath: row.sourcecodepath
        }));
        const wrapColumns = ["TestScenario", "StoryDescription", "TestSteps"];
        const timestamp = new Date().toISOString();
        const sheetName = "Generated_Test_Cases_" + timestamp;
        this.excelExportService.exportToExcel(
          formattedData,
          sheetName,
          "Test Cases",
          wrapColumns
        );
      }
  }
}
